import { NgModule } from '@angular/core';
import { UiPartsModule } from '@shared/modules/ui/ui-parts/ui-parts.module';
import { RouterModule } from '@angular/router';
import { AppVersionComponent } from './app-version/app-version.component';
import { CopyrightComponent } from './copyright/copyright.component';
import { BugReportComponent } from './bug-report/bug-report.component';

@NgModule({
  declarations: [AppVersionComponent, CopyrightComponent],
  imports: [UiPartsModule, RouterModule, BugReportComponent],
  exports: [CopyrightComponent, BugReportComponent],
})
export class ConfigSharedComponentsModule {}
